<div class="account-dash-row">
  <div class="card-with-shadow card-with-shadow--orange content-mask-container">
    <div class="content-mask" *ngIf="loadingStatsmanData">
      <ab-spinner></ab-spinner>
    </div>
    <div class="ab-account-cards" *ngIf="errorCardsData">
      <div class="dash-cta" *ngIf="hasNoErrors && !featureDisabled">
        <h4 class="dash-cta__title">
          <i class="glyphicon glyphicon--valign-baseline glyphicon-bug"></i>
          Errors
        </h4>
        <p>Almost there - install Airbrake to start monitoring errors.</p>
        <div class="dash-cta__image">
          <div class="ab-bugs">
            <img
              class="ab-bugs__bug-small"
              src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/bug.svg"
            />
            <img
              class="ab-bugs__bug-medium"
              src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/bug.svg"
            />
            <img
              class="ab-bugs__bug-large"
              src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/bug.svg"
            />
          </div>
        </div>
        <p *ngIf="projects">
          <a
            class="btn btn--primary"
            uiSref="project-errors"
            [uiParams]="{ projectId: projects[0].id }"
          >
            Install Airbrake
          </a>
        </p>
      </div>
      <ab-account-cards
        [projects]="errorCardsData"
        [dur]="dur"
        [user]="user"
        *ngIf="!hasNoErrors"
      >
      </ab-account-cards>
    </div>
    <div class="ab-chart mt-3" *ngIf="!hasNoErrors && errorCardsData">
      <ab-line-chart
        class="ab-chart__chart"
        [config]="errorLinechartData"
      ></ab-line-chart>
    </div>
  </div>
  <div
    class="card-with-shadow card-with-shadow--blue card-slide content-mask-container"
    [ngClass]="{ 'is-slid': openedDeployList }"
  >
    <div class="content-mask" *ngIf="loadingStatsmanData">
      <ab-spinner></ab-spinner>
    </div>
    <div class="dash-cta" *ngIf="hasNoDeploys && !featureDisabled">
      <h4 class="dash-cta__title">
        <i class="glyphicon glyphicon--valign-baseline glyphicon-flash"></i>
        Deploys
      </h4>
      <p>Find the errors in all your deploys.</p>
      <div class="dash-cta__image">
        <img
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/deploys-list.svg"
          alt=""
        />
      </div>
      <p *ngIf="projects">
        <a
          class="btn btn--secondary"
          uiSref="project-deploys"
          [uiParams]="{ projectId: projects[0].id }"
        >
          Set up Deploy tracking
        </a>
      </p>
    </div>
    <div class="card-slide__top" *ngIf="!hasNoDeploys">
      <div
        class="ab-account-cards"
        *ngIf="deployCountData || deploysWithErrors"
      >
        <ab-account-deploy-cards
          [deployCountData]="deployCountData"
          [deploysWithErrorsCount]="deploysWithErrors?.count"
          [dur]="dur"
        ></ab-account-deploy-cards>
      </div>
      <div class="ab-chart mt-3">
        <ab-line-chart
          class="ab-chart__chart"
          [config]="deployLinechartData"
        ></ab-line-chart>
      </div>
      <button
        class="btn btn--link-color btn--no-shadow d-block w-100 text-center"
        (click)="openedDeployList = !openedDeployList"
        *ngIf="deploysWithErrors?.count > 0"
      >
        Deploys with the most new errors
        <i
          class="glyphicon glyphicon--valign-baseline"
          [ngClass]="
            openedDeployList ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down'
          "
        >
        </i>
      </button>
    </div>

    <div class="card-slide__bottom" *ngIf="deploysWithErrors?.count > 0">
      <ab-deploys-with-errors
        [deployData]="deploysWithErrors"
        [projects]="projects"
        [loading]="loadingDeployStats"
      ></ab-deploys-with-errors>
    </div>
  </div>
  <div class="card-with-shadow card-with-shadow--green content-mask-container">
    <div class="content-mask" *ngIf="loadingPerformanceStats">
      <ab-spinner></ab-spinner>
    </div>
    <div class="ab-account-cards" *ngIf="performanceCardsData">
      <div class="dash-cta" *ngIf="hasNoRequests && !featureDisabled">
        <h4 class="dash-cta__title">
          <i
            class="glyphicon glyphicon--valign-baseline glyphicon-ab-gauge"
          ></i>
          Performance
        </h4>
        <p>Monitor the overall quality of your applications.</p>
        <div class="dash-cta__image">
          <img
            src="{{ appEnv.cdnUrl }}/{{
              appEnv.assetsPath
            }}/images/performance-graph.svg"
            alt=""
          />
        </div>
        <p *ngIf="projects">
          <a
            class="btn btn--success"
            uiSref="project-performance"
            [uiParams]="{ projectId: projects[0].id }"
          >
            Install Performance Monitoring
          </a>
        </p>
      </div>
      <ab-account-performance-cards
        *ngIf="!hasNoRequests"
        [data]="performanceCardsData"
        [dur]="dur"
      ></ab-account-performance-cards>
    </div>
    <div class="ab-chart mt-3" *ngIf="!hasNoRequests && performanceCardsData">
      <ab-line-chart
        class="ab-chart__chart"
        [config]="performanceLinechartData"
      ></ab-line-chart>
    </div>
  </div>
</div>

<div class="card-with-shadow card-with-shadow--full-width pt-0">
  <div class="ab-table-wrap">
    <table class="ab-table">
      <thead>
        <tr>
          <th class="ab-table__header"></th>
          <th class="ab-table__header"></th>
          <th class="ab-table__header ab-table__header--orange"></th>
          <th
            class="ab-table__header ab-table__header--left-border ab-table__header--orange"
          >
            Errors
          </th>
          <th class="ab-table__header ab-table__header--orange"></th>
          <th
            class="ab-table__header ab-table__header--left-border ab-table__header--orange"
          >
            Occurrences
          </th>
          <th class="ab-table__header ab-table__header--orange"></th>
          <th
            class="ab-table__header ab-table__header--left-border ab-table__header--blue"
          ></th>
          <th
            class="ab-table__header ab-table__header--left-border ab-table__header--green"
          >
            Response time
          </th>
          <th class="ab-table__header ab-table__header--green">(percentile)</th>
          <th class="ab-table__header ab-table__header--green"></th>
          <th class="ab-table__header ab-table__header--green"></th>
        </tr>
        <tr>
          <th class="ab-table__header ab-table__header--55w">
            <a class="th-link" (click)="sortBy('errorLinechartData.showLine')"
              >Plot<i
                class="glyphicon th-link__icon"
                *ngIf="column === 'errorLinechartData.showLine'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i
            ></a>
          </th>
          <th class="ab-table__header">
            <a class="th-link" (click)="sortBy('name')"
              >Project<i
                class="glyphicon th-link__icon"
                *ngIf="column === 'name'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i
            ></a>
          </th>
          <th class="ab-table__header"></th>
          <th class="ab-table__header ab-table__header--left-border">
            <a class="th-link" (click)="sortBy('newGroupCount')"
              >New<i
                class="glyphicon th-link__icon"
                *ngIf="column === 'newGroupCount'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i
            ></a>
          </th>
          <th class="ab-table__header">
            <a class="th-link" (click)="sortBy('groupUnresolvedCount')"
              >Unresolved<i
                class="glyphicon th-link__icon"
                *ngIf="column === 'groupUnresolvedCount'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i
            ></a>
          </th>
          <th class="ab-table__header ab-table__header--left-border">
            <a class="th-link" (click)="sortBy('lastNoticeAt')"
              >Latest<i
                class="glyphicon th-link__icon"
                *ngIf="column === 'lastNoticeAt'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i
            ></a>
          </th>
          <th class="ab-table__header">
            <a class="th-link" (click)="sortBy('acceptedNoticeCount')"
              >Accepted<i
                class="glyphicon th-link__icon"
                *ngIf="column === 'acceptedNoticeCount'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i
            ></a>
          </th>
          <th class="ab-table__header ab-table__header--left-border">
            <a class="th-link" (click)="sortBy('deployCount')">
              Deploys
              <i
                class="glyphicon th-link__icon"
                *ngIf="column === 'deployCount'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i>
            </a>
          </th>
          <th class="ab-table__header ab-table__header--left-border">
            <a class="th-link" (click)="sortBy('p50')">
              50TH
              <i
                class="glyphicon th-link__icon"
                *ngIf="column === 'p50'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i>
            </a>
          </th>
          <th class="ab-table__header">
            <a class="th-link" (click)="sortBy('p95')">
              95TH
              <i
                class="glyphicon th-link__icon"
                *ngIf="column === 'p95'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i>
            </a>
          </th>
          <th class="ab-table__header ab-table__header--left-border">
            <a class="th-link" (click)="sortBy('requestCount')">
              Requests
              <i
                class="glyphicon th-link__icon"
                *ngIf="column === 'requestCount'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i>
            </a>
          </th>
          <th class="ab-table__header">
            <ng-template #apdexTooltip>
              <ab-apdex-tooltip-text></ab-apdex-tooltip-text>
            </ng-template>
            <a
              class="th-link"
              (click)="sortBy('apdexScore')"
              [ngbTooltip]="apdexTooltip"
              container="body"
              closeDelay="2000"
            >
              Apdex
              <i
                class="glyphicon th-link__icon"
                *ngIf="column === 'apdexScore'"
                [ngClass]="{
                  'glyphicon-caret-up': !sortDesc,
                  'glyphicon-caret-down': sortDesc
                }"
              ></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="ab-table__row"
          *ngFor="let project of projects; trackBy: trackBy"
        >
          <td class="ab-table__cell">
            <div
              class="ab-checkbox float-left"
              [ngClass]="
                'ab-checkbox--' + project.errorLinechartData?.colorName
              "
            >
              <input
                id="plotProject{{ project.id }}"
                type="checkbox"
                [checked]="project.errorLinechartData?.showLine"
                (click)="plotProject(project, $event)"
              />
              <label
                class="ab-checkbox__label"
                for="plotProject{{ project.id }}"
              ></label>
            </div>
          </td>
          <td class="ab-table__cell ab-table__cell--max-width">
            <a
              class="text-truncate"
              uiSref="project-errors"
              [uiParams]="{ projectId: project.id }"
              >{{ project.name }}</a
            >
          </td>
          <td class="ab-table__cell">
            <div class="ab-chart ab-chart--mini">
              <ab-stacked-bar-chart
                class="ab-chart__chart"
                [config]="project.barchartConfig"
              ></ab-stacked-bar-chart>
            </div>
          </td>
          <td class="ab-table__cell">
            <a
              uiSref="project-errors"
              [uiParams]="{
                projectId: project.id,
                filters: { order: 'created', resolved: 'any' }
              }"
              >{{ project.newGroupCount | numberToHuman }}</a
            >&nbsp;
            <ab-trend
              class="ab-table__trend"
              [countList]="project.newGroupCountList"
              [dur]="dur"
              [statType]="'new errors'"
            ></ab-trend>
          </td>
          <td class="ab-table__cell">
            <a
              uiSref="project-errors"
              [uiParams]="{
                projectId: project.id,
                filters: { order: 'created', resolved: 'false' }
              }"
              >{{ project.groupUnresolvedCount | numberToHuman }}</a
            >
          </td>
          <td class="ab-table__cell">
            <span *ngIf="project.lastNoticeAt">
              <ab-time-ago [time]="project.lastNoticeAt"></ab-time-ago></span
            ><span *ngIf="!project.lastNoticeAt">-</span>
          </td>
          <td class="ab-table__cell">
            {{ project.acceptedNoticeCount | numberToHuman }}
            &nbsp;
            <ab-trend
              class="ab-table__trend"
              [countList]="project.acceptedNoticeCountList"
              [dur]="dur"
              [statType]="'accepted errors'"
            ></ab-trend>
          </td>
          <td class="ab-table__cell">
            <a
              uiSref="project-deploys"
              [uiParams]="{ projectId: project.id }"
              >{{ project.deployCount | numberToHuman }}</a
            >&nbsp;
            <ab-trend
              class="ab-table__trend"
              [countList]="project.deployCountList"
              [dur]="dur"
              [statType]="'deploys'"
              [neutralStyle]="true"
            ></ab-trend>
          </td>
          <td class="ab-table__cell">
            <a
              uiSref="project-performance"
              [uiParams]="{ projectId: project.id, dur: dur, last_n: lastN }"
            >
              <ab-duration-format
                [milliseconds]="project.p50"
              ></ab-duration-format>
            </a>
            &nbsp;
            <ab-trend
              class="ab-table__trend"
              [countList]="project.p50List"
              [dur]="dur"
              [statType]="'response time'"
              [performanceTrend]="true"
            ></ab-trend>
          </td>
          <td class="ab-table__cell">
            <a
              uiSref="project-performance"
              [uiParams]="{ projectId: project.id, dur: dur, last_n: lastN }"
            >
              <ab-duration-format
                [milliseconds]="project.p95"
              ></ab-duration-format>
            </a>
            &nbsp;
            <ab-trend
              class="ab-table__trend"
              [countList]="project.p95List"
              [dur]="dur"
              [statType]="'response time'"
              [performanceTrend]="true"
            ></ab-trend>
          </td>
          <td class="ab-table__cell">
            <a
              uiSref="project-performance"
              [uiParams]="{ projectId: project.id, dur: dur, last_n: lastN }"
            >
              {{ project.requestCount | numberToHuman }}
            </a>
            <ab-trend
              class="ab-table__trend"
              [countList]="project.requestCountList"
              [dur]="dur"
              [statType]="'requests'"
              [neutralStyle]="true"
            ></ab-trend>
          </td>
          <td class="ab-table__cell">
            <a
              uiSref="project-performance"
              [uiParams]="{ projectId: project.id, dur: dur, last_n: lastN }"
            >
              {{ project.apdexScore?.toFixed(2) }}
            </a>
            <ab-trend
              class="ab-table__trend"
              [countList]="project.apdexScoreList"
              [dur]="dur"
              [statType]="'apdex score'"
              [performanceTrend]="true"
              [increasePositive]="true"
            ></ab-trend>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
